export enum ModalName {
  CarouselItem = 'AddOrUpdateLoginCarouselItemModal',
}
